/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Gallery_SubtitleInputs */



/**
* | output |
* | --- |
* | "Start a new space directly from one of your tools." |
*
* @param {Spaces_Gallery_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_gallery_subtitle = /** @type {((inputs?: Spaces_Gallery_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstelle einen neuen Space direkt aus einem deiner Tools.")
	return /** @type {LocalizedString} */ ("Start a new space directly from one of your tools.")
});